export function simpleStore<T>(state: T) {
    const subscribers = new Set<() => void>();
    return {
        subscribe(callback: () => void) {
            subscribers.add(callback);
            return () => {
                subscribers.delete(callback);
            };
        },
        snapshot() {
            return state;
        },
        setState(level: T) {
            state = level;
            subscribers.forEach(notify => notify());
        },
    };
}
